var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltRebates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00011 18H3.00011L4.00011 11H0.500114C-0.0798864 11 -0.0698865 10.68 0.120113 10.34C0.310113 10 0.170114 10.26 0.190114 10.22C1.48011 7.94 3.42011 4.54 6.00011 0H7.00011L6.00011 7H9.50011C9.99011 7 10.0601 7.33 9.97011 7.51L9.90011 7.66C5.96011 14.55 4.00011 18 4.00011 18Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltRebates);
export default __webpack_public_path__ + "static/media/BoltRebates.33e7a6fb8aac59e4b97a72c120c70231.svg";
export { ForwardRef as ReactComponent };